import { ReactElement, Suspense } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { ThemeProvider as AsphaltThemeProvider } from '@asphalt-react/theme-provider'
import { lynx } from '@gojek/theme-asphalt-web-lynx'
import { StoreProvider } from 'contexts'
import theme from 'theme'
import { GlobalStyles } from 'theme/GlobalStyles'
import routes from './routes'
import Image from 'components/common/Image'

import logo from 'logo.svg'
import tselLogo from '../assets/images/tsel-logo.png'

const router = createBrowserRouter(routes)

const Router = (): ReactElement => {
    const isUserRoute = window.location.pathname.startsWith('/user')
    const isPbpRoute = /^\/payment\/via-phone(?:\/|$|\?)/.test(
        window.location.pathname
    )

    const suspenseContent = (
        <Suspense
            fallback={
                <div
                    style={{
                        minHeight: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Image
                        src={isUserRoute ? tselLogo : logo}
                        className="pointer-events-none animation-shake"
                        alt="logo"
                        height="100px"
                        width="100px"
                    />
                </div>
            }
        >
            <RouterProvider router={router} />
        </Suspense>
    )

    if (isPbpRoute) {
        return (
            <AsphaltThemeProvider theme={lynx} responsive>
                {suspenseContent}
            </AsphaltThemeProvider>
        )
    }

    return (
        <ThemeProvider theme={theme}>
            <StoreProvider>
                <GlobalStyles />
                {suspenseContent}
            </StoreProvider>
        </ThemeProvider>
    )
}

export default Router
